import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { BotStatusEntityService } from '@views/pages/apps/settings/bot-status/service/bot-status-entity.service';


@Injectable()
export class BotStatusResolver implements Resolve<boolean> {

    constructor(private botStatusEntityService: BotStatusEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.botStatusEntityService.loaded$.pipe(
          tap(loaded =>  {
            if(!loaded) {
              this.botStatusEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
